<dialog-draggable-header>
  Change Log
</dialog-draggable-header>

<data-table #dataTable [data]="changelogs" [columns]="columns" [filterColumnDisplay]="false" [paging]="true"
  [pageSize]="this.page.size" [totalRecords]="total" [lazy]="true" (lazyLoad)="onLazyLoad($event)" [loading]="loading"
  [showNumberColumn]="false" [showAllPaging]="false" [lazyLoadOnInit]="false">
  <ng-container actionStart>
    <button *ngIf="isSuperUser() | async" mat-button (click)="addChangeLog()">Add</button>
    <button *ngIf="isSuperUser() | async" mat-button (click)="editChangeLog()">Edit</button>
    <button *ngIf="isSuperUser() | async" mat-button (click)="deleteChangeLog()">Delete</button>
  </ng-container>
  <ng-container actionEnd>
    <button mat-dialog-close mat-button> Close </button>
  </ng-container>
</data-table>